let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("71VqN")).then(() => parcelRequire('4cmqO'));